/* global angular */
( function () {
	'use strict';

	function HideScoringCtrl ( templateModel, $modalInstance, config ) {
		var self = this;

		function confirmModal () {
			templateModel.hideScoring = !self.showScoring;
			$modalInstance.dismiss( 'cancel' );
		}

		self.confirmModal = confirmModal;
		self.showScoring  = !templateModel.hideScoring;
		self.isViewOnly   = config.isViewOnly;
	}

	angular
		.module( 'app.templates' )
		.controller( 'templateHideScoringCtrl', HideScoringCtrl );

	HideScoringCtrl.$inject = [ 'templateModel', '$modalInstance', 'config' ];
} )( );
